import React from 'react';
import { Link } from '@mui/material';

export const contactLink = (text: React.ReactNode) => (
  <Link
    target='_top'
    rel='noopener noreferrer'
    href={'mailto:support@mybrightlink.org'}
    sx={{
      fontWeight: 500,
    }}
  >
    {text}
  </Link>
);
